<template>
  <div>
    <div
      class="box"
      id="pageContent"
      :style="{ 'min-height': pageContentHight }"
    >
      <div class="bf" style="width:100%">
        <div class="header-box" style="width: 100%">
          <div class="bor" style="width: 100%">
            <div
              class="dis-flex flex-between flex-middle width-center "
              style="height: 96px"
            >
              <a href>
                <img src="@/assets/fdasfasdf.png" alt style="height: 44px" />
              </a>
              <div class="input-box">
                <div class="headerSearchBox">
                  <div class="headerSearchMain">
                    <div class="headerSearchInput">
                      <img src="@/assets/3333.png" class="seimg" alt="" />
                      <input
                        type="text"
                        v-model="searchKey"
                        placeholder="想学什么？搜一搜"
                      />
                    </div>
                    <span class="loginBtn" @click="seacrh">搜索</span>
                  </div>
                </div>
              </div>
              <div class="dis-flex flex-middle">
                <Dropdown v-if="userInfo && JSON.stringify(userInfo) != '{}'">
                  <a
                    href="javascript:void(0)"
                    class="dis-flex flex-center flex-middle"
                  >
                    <img
                      style="width: 36px; height: 36px; margin-right: 10px"
                      class="ji"
                      :src="
                        userInfo.portraitImg ||
                          'https://www.ciclink.cn/file/avatar.png'
                      "
                      alt
                    />
                    <span class="user-name">{{ userInfo.nickName }}</span>
                  </a>
                  <DropdownMenu slot="list">
                    <DropdownItem @click.native="myi">我的课程</DropdownItem>
                    <DropdownItem @click.native="myOrder"
                      >我的订单</DropdownItem
                    >
                    <DropdownItem>
                      <div style="color: #ff95b1" @click="exit">退出登录</div>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
                <div
                  class="loginBtn"
                  style="margin-left: 20px"
                  @click="sign"
                  v-else
                >
                  登录
                </div>
              </div>
            </div>
          </div>
          <div class="width-center">
            <Menu
              style="margin-left: -20px"
              mode="horizontal"
              :active-name="$route.name"
            >
              <MenuItem name="index" to="/" class="nati">首页</MenuItem>
              <MenuItem name="industry" to="/industry" class="nati"
                >资讯</MenuItem
              >
              <MenuItem name="train" to="/train" class="nati">科普</MenuItem>
              <MenuItem name="expert" to="/expert" class="nati">培训</MenuItem>
            </Menu>
          </div>
        </div>
      </div>
      <!-- 中间的内容 -->
      <div class="dis-flex app-my" v-if="uiMy">
        <router-view ref="myG"></router-view>
      </div>
    </div>
    <!-- 底部 -->
    <div class="bottom">
      <footer class="clearfix">
        <div style="width: 100%" class="dis-flex flex-between">
          <div class="dis-flex">
            <div>
              <div class="dis-flex">
                <a href="#/aboutMy" class="about-my" target="_blank"
                  >关于我们</a
                >
              </div>
              <div class="bout">
                <a href="#/jieshao" target="_blank">学会介绍</a>
                <a href="#/proto" target="_blank">用户协议</a>
              </div>
              <div class="bout">
                <a href="#/aboutMy" target="_blank">关于我们</a>
                <a href="#/shengming" target="_blank">版权说明</a>
              </div>
            </div>
            <div style="margin-left: 100px">
              <div class="about-my">友情链接</div>
              <div class="bout">
                <a href="https://www.miit.gov.cn/" target="_blank"
                  >工业和信息化部</a
                >
                <a href="http://www.china-cic.cn/" target="_blank"
                  >中国通信学会</a
                >
              </div>
              <div class="bout">
                <a href="http://www.caict.ac.cn/" target="_blank"
                  >中国信息通信研究院</a
                >
                <a href="https://www.china-aii.com/" target="_blank"
                  >中国工业互联网研究院</a
                >
              </div>
            </div>
          </div>
        </div>
        <p class="footTip">
          <a
            href="https://beian.miit.gov.cn"
            target="_blank"
            style="color: #ffffff"
            >Copyright ©CIC科教网 京ICP备2020038142号-1</a
          >
        </p>
      </footer>
    </div>
    <!-- 登录 -->
    <div v-if="modal1" class="sigin-box dis-flex flex-center flex-middle">
      <div class="img-box">
        <div class="colse">
          <img
            src="@/assets/编组 12.png"
            style="width: 27px"
            @click="colseRegister"
            alt
          />
        </div>
        <img src="@/assets/组 3.png" class="sigin-img" alt />
        <div class="code-box">
          <img
            :src="loginData.url"
            frameborder="0"
            scrolling="no"
            style="width: 139px"
            alt
          />
          <div class="weix">微信扫码登录</div>
        </div>
      </div>
    </div>
    <!-- 右边悬浮的导航栏 -->
    <ul class="r-fixed-ul flex-column flex-middle">
      <li v-if="topBottom">
        <a href="#" @click="toTop">
          <img src="@/assets/zhiding.png" alt class />
        </a>
      </li>
      <li style="position: relative" class="right-a">
        <div>
          <img src="@/assets/kefu.png" alt class />
        </div>
        <div class="gotoServer-wx active-i">
          <div class="footedBox">
            <div class="footedBackgroud flex-column">
              <p
                style="width: 134px; height: 134px; margin: 9px auto 0px"
                class="red"
              >
                <img
                  src="@/assets/wwwwww.jpg"
                  id="WXgzh"
                  onerror="nofind();"
                  style="display: block; width: 100%"
                />
              </p>
              <div class="phoneText" style="text-align: center">
                <p>13352806206</p>
                <p style="font-size: 12px;">【微信同号】</p>
              </div>
            </div>
            <div class="wx-sjx"></div>
          </div>
        </div>
      </li>
      <!-- <li style="position: relative" class="right-b">
        <a href="#"><img src="@/assets/yidong.png" alt="" class="" /></a>
        <div class="gotoServer-wx active-i">
          <div class="footedBox">
            <div class="footedBackgroud">
              <p
                style="width: 134px; height: 134px; margin: 9px auto 10px"
                class="red"
              >
                <img
                  src="@/assets/gzh.png"
                  id="WXgzh"
                  onerror="nofind();"
                  style="display: block; width: 100%"
                />
              </p>
              <div class="phoneText" style="text-align: center">
                <p>微信扫描图中二维码</p>
                <p>关注【 CIC科教网 】</p>
              </div>
            </div>
            <div class="wx-sjx"></div>
          </div>
        </div>
      </li>-->
      <li style="position: relative" class="right-c">
        <a href="#">
          <img src="@/assets/gongzhonghao.png" alt class />
        </a>
        <div class="gotoServer-wx active-i">
          <div class="footedBox">
            <div class="footedBackgroud">
              <p
                style="width: 134px; height: 134px; margin: 9px auto 0px"
                class="red"
              >
                <img
                  src="@/assets/gga.jpg"
                  id="WXgzh"
                  onerror="nofind();"
                  style="display: block; width: 100%"
                />
              </p>
              <div class="phoneText" style="text-align: center">
                <!-- <p>微信扫描图中二维码</p> -->
                <!-- <p>关注【 CIC科教网 】</p> -->
                <p>扫码关注【CIC科教网】</p>
              </div>
            </div>
            <div class="wx-sjx"></div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import bus from "@/utils/bus";
import { mapState } from "vuex";
export default {
  data() {
    return {
      modal1: false,
      topBottom: false,
      customer: false,
      move: false,
      account: false,
      loginData: {},
      aread: false,
      uiMy: true,
      userInfo: {},
      timeObj: null,
      pageContentHight: "",
      searchKey: "",
    };
  },
  created() {
    this.listenerFunction();
    // console.log('window.innerHeight', window.innerHeight)
    //document.getElementById("pageContent").clientHight = document.body.clientHight;
    this.pageContentHight = window.innerHeight + "px";
  },
  mounted() {
    this.getUserInfo();
    bus.$on("message", (e) => {
      if (e) {
        this.sign();
      }
    });
  },
  methods: {
    async exit() {
      await this.$api.get("/pc/api/login/exit");
      this.userInfo = {};
      localStorage.setItem("isLogin", false);
      this.$router.push({
        path: "/",
      });
    },
    getUserInfo() {
      var then = this;
      this.$api
        .get("pc/api/user/userInfo")
        .then((data) => {
          if (!data) {
            localStorage.setItem("isLogin", false);
          } else {
            localStorage.setItem("isLogin", true);
            then.userInfo = data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
      // let { data } = await this.$api.get("pc/api/user/userInfo");
      // this.userInfo = data;
    },
    colseRegister() {
      this.modal1 = false;
    },
    async sign() {
      this.modal1 = true;
      let { data } = await this.$api.get(
        "pc/api/qrCode/getLoginQrCodeTicketAndUrl"
      );
      this.loginData = data;
      let { ticket } = data;
      this.timeObj = setInterval(() => {
        if (this.modal1) {
          this.$api.get("pc/api/qrCode/loginStatus", { ticket }).then((e) => {
            if (e.data) {
              this.uiMy = false;
              clearInterval(this.timeObj);
              this.modal1 = false;
              this.aread = true;
              this.uiMy = true;
              this.$router.push("/");
              this.getUserInfo();
            }
          });
        }
      }, 2000);
    },
    toTop() {
      window.scrollTo(0, 0);
    },
    listenerFunction(e) {
      let that = this;
      document.addEventListener(
        "scroll",
        function() {
          if (window.pageYOffset < 300) {
            that.topBottom = false;
            return;
          } else if (window.pageYOffset > 300) {
            that.topBottom = true;
          }
        },
        true
      );
    },
    seacrh() {
      let { searchKey } = this;
      if (this.$route.name == "industry") {
        //文章
        // console.log('qqqq',)
        this.$refs.myG.getArticle(this.$refs.myG.value, 1, searchKey);
      } else if (this.$route.name == "train") {
        this.$refs.myG.getArticle(this.$refs.myG.value, "视频", 1, searchKey);
      } else if (this.$route.name == "expert") {
        this.$refs.myG.getArticle(this.$refs.myG.value, searchKey);
      }
    },
    myi() {
      this.$router.push({
        //核心语句
        path: "/study", //跳转的路径
        query: {
          pageNo: 0,
        },
      });
    },
    myOrder() {
      this.$router.push({
        //核心语句
        path: "/study", //跳转的路径
        query: {
          pageNo: 1,
        },
      });
    },
  },
  computed: mapState({
    count: (state) => state.lo, // 组件内的每一个属性函数都会获得一个默认参数state, 然后通过state 直接获取它的属性更简洁
  }),
};
</script>

<style scoped lang="scss">
.seimg {
  width: 15px;
  position: absolute;
  top: 50%;
  margin-top: -7px;
  left: 12px;
}
.user-name {
  font-size: 16px;
}
.header-box {
  // background: red;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
}
.about-my {
  height: 22px;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  text-align: left;
  // padding-bottom: 10px;
  margin-bottom: 10px;
}
.bout1 {
  font-size: 14px;
  line-height: 20px;
  float: left;
  margin-right: 10px;
}
.bout {
  font-size: 14px;
  line-height: 20px;
  float: left;
  margin-right: 10px;
}
.i {
  color: #093fd5;
}
.bout {
  a {
    text-align: left;
    font-size: 12px;
    font-weight: 400;
    color: #ffffff;
    text-align: left;
    display: block;
  }
}
.bo-time {
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
}
.dianh {
  font-size: 30px;
  font-weight: 600;
  color: #ffffff;
  line-height: 42px;
}
.app-my {
  width: 100%;
}
.nati {
  font-size: 18px;
  font-weight: 500;
  color: #4a4a4a;
}
.ji {
  border-radius: 50%;
  overflow: hidden;
}
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu {
  border-bottom: 0px;
}
.box {
  margin: auto;
  box-sizing: border-box;
  background: #fafcfd;
}
.a {
  width: 100%;
  height: 230px;
}
.loginBtn {
  width: 80px;
  height: 37px;
  line-height: 37px;
  font-size: 16px;
  background: linear-gradient(148deg, #0dcadb 0%, #093fd5 100%);
  border-radius: 20px;
  text-align: center;
  color: #ffffff;
  margin-right: -1px;
}
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active,
.ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
  border-bottom: 0px solid #2d8cf0;
}
.ivu-menu-horizontal.ivu-menu-light:after {
  display: none;
}
.r-fixed-ul {
  position: fixed;
  right: 0;
  // background: red;
  width: 61px;
  top: 0px;
  z-index: 100;
  top: 28%;
  // width: ;
  padding: 7px;
  // padding-bottom: 14px;
  img {
    // width: 100%;
    width: 45px;
    margin-bottom: 20px;
    // box-shadow: 0 3px 6px #d3e0ef;
    border-radius: 50%;
    overflow: hidden;
  }
}
.bottom {
  //   background-color: red;
  background: #121c32;
  text-align: center;
  border: 0;
}
.b-foot-box {
  padding-top: 20px;
  display: flex;
  align-items: center;
}
.footTip {
  font-size: 12px;
  font-weight: 100;
  color: #ffffff;
  line-height: 20px;
  padding-top: 30px;
  padding-bottom: 20px;
}
.footText {
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
  line-height: 22px;
}
.footText1 {
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  line-height: 20px;
}
.footerPhoneNum {
  font-size: 30px;
  font-weight: 600;
  color: #ffffff;
  line-height: 42px;
}
.flink-list {
  margin-top: 0;
  display: flex;
}
.flink-list li a {
  color: #ddd;
}
.b-f-link {
  display: flex;
  justify-content: center;
}
.footer-wx {
  width: 100px;
  height: 100px;
  display: inline-block;
}
.clearfix {
  width: 1160px;
  // background: blue;
  margin: auto;
  padding-top: 30px;
}
// #footer{overflow:inherit;left:0;bottom:0;position: absolute;padding:0;}
.footer-icon-wx-tip {
  position: absolute;
  bottom: -19px;
  right: 50%;
  margin-right: -10px;
}
.flink-list {
  flex: 1;
}
.footerItem {
  text-align: left;
}
.footerItem span {
  padding-right: 10px;
}
.footerItem span a {
  font-size: 12px;
}
.footerItem span a.footText1 {
  font-size: 14px;
  font-weight: lighter;
}
.footer-icon {
  color: #ffffff;
  text-align: left;
  font-size: 14px;
}
.headerSearchMain {
  width: 420px;
  height: 35px;
  border-radius: 20px;
  // border: 1px solid #cdcdcd;
  display: flex;
  background: rgba(210, 210, 210, 0.47);
  padding-left: 35px;
  position: relative;
  input:focus {
    outline: none;
  }
}
.headerSearchMain .loginBtn {
  height: 35px !important;
  line-height: 35px !important;
  margin-top: -1px;
  cursor: pointer;
}
.headerSearchInput {
  height: 35px;
  line-height: 35px;
  flex: 1;
  // padding: 0 15px;
}
.headerSearchInput input {
  width: 100%;
  height: 100%;
  border: 0;
  font-size: 16px;
  background: transparent;
  color: #353535;

  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #4a4a4a;
}
.headerSearchInput input::placeholder {
  color: #949494;
}
.headerTabNav {
  display: flex;
  align-items: center;
}
.reset-box {
  width: 330px;
  margin: 0 auto;
  // padding-top: 80px;
}
.header-content-text {
  /*padding-left: 80px;*/
  height: 60px;
}
.reset-icon {
  position: absolute;
  top: 10px;
  left: 4px;
}

.resetground {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.reset-ground {
  height: 42px;
  width: 100%;
  display: inline-block;
  background-color: #fff;
  margin: 10px 0;
}
.reset-ground input {
  border: 0;
  height: 40px;
  line-height: 40px;
  width: 99%;
  text-indent: 2em;
  border: 1px solid #95989a;
}
.reset-ground.input-code {
  width: 58%;
}
.reset-tip {
  position: absolute;
  top: 0;
  right: 0;
  line-height: 40px;
  padding-right: 10px;
}
.reset-tip-btn {
  border: 1px solid #1b85fc;
  color: #1b85fc;
  margin-left: 18px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
  width: 114px;
  text-align: center;
  border-radius: 5px;
  background-color: #fff;
}
.reset-tip-pic {
  border: 0;
  width: 110px;
  height: 36px;
  padding-top: 14px;
  margin-left: 28px;
  display: inline-block;
}
.pwd-btn {
  width: 100%;
  border-radius: 5px;
  color: #fff;
  background-color: #1b85fc;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin-top: 10px;
  font-size: 14px;
  position: relative;
  padding: 0;
}
.input-eyes {
  position: absolute;
  top: 20px;
  right: 5px;
  cursor: pointer;
}
.reset-icon-eyes {
  padding-right: 30px;
}
.enroll-btn {
  width: 80px;
  color: #1b85fc;
  border: 1px solid #1b85fc;
  padding: 5px 20px;
  border-radius: 5px;
}
.img111 {
  width: 100%;
  height: 100%;
}
.other-login {
  margin-top: 32px;
  border-top: 1px solid #ddd;
}
.other-login-icon {
  padding: 10px 0;
}
.other-login-icon span {
  padding: 0 20px;
}
.login-colse {
  position: absolute;
  top: 10px;
  right: 20px;
  z-index: 99;
}
.btd {
  border-top: 1px solid #ddd;
}
.login-box {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999999;
  left: 50%;
  top: 50%;
  margin: -333px 0 0 -165px;
}
.bingdingError_text {
  margin-top: 10%;
  margin-bottom: 40px;
}
.gotoServer-wx {
  position: absolute;
  bottom: -72px;
  left: -200px;
  display: none;
  // margin-
  margin-bottom: 25px;
  .wx-sjx {
    width: 14px;
    height: 16px;
    background: url("../../assets/phoneTip.png") no-repeat;
    transform: rotate(90deg);
  }
}
.footedBox {
  flex: 1;
  display: flex;
  align-items: center;
}
.footedBackgroud {
  background: #ffffff;
  min-width: 178px;
  // height: 182px;
  box-shadow: 0 3px 6px #c8c8c8;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  padding: 0 15px;
  padding-bottom: 10px;
  img {
    border-radius: 0%;
  }
}
.phoneText p {
  line-height: 20px;
  font-size: 14px;
  color: #4a4a4a;
}
.red {
  background: red;
}
#WXgzh {
  z-index: 10000000;
}
.ivu-menu {
  z-index: 0;
}
// .right-a{
//     background: red;
//   width: 100px;
//   height: 100px;
// }
.right-a:hover {
  .active-i {
    display: block;
    z-index: 10000;
  }
}
.right-b:hover {
  .active-i {
    display: block;
    z-index: 10000;
  }
}
.right-c:hover {
  .active-i {
    display: block;
    z-index: 10000;
  }
}
.sigin-box {
  //  height: 268px;
  height: 100vh;
  width: 100%;
  background: rgba(40, 40, 40, 0.5);
  // position: flex;
  position: fixed;
  top: 0;
  left: 0;
  .img-box {
    height: 268px;
    position: relative;
    .sigin-img {
      // height: 268px;
    }
    .colse {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 100;
    }
    .code-box {
      //  width;
      // background: red;
      position: absolute;
      top: 50%;
      left: 50%;
      // top: -;
      // margin-top: -69px;
      // margin-left: -69px;
      transform: translateX(-50%) translateY(-31%);
      .weix {
        text-align: center;

        font-size: 14px;
        font-weight: 400;
        color: #516cd6;
      }
      img {
        width: 139px;
        height: 138px;
      }
    }
  }
}
</style>
